<template>
	<div id="divquestoes">
		<div class="card mb-6" style="border-radius: 13px">
			<div class="card-body pt-0 pr-0 pl-0 pb-0">
				<div class="d-flex flex-wrap flex-sm-nowrap">
					<div class="row">
						<div class="col-md-12 pt-3">
							<div class="col-md-12 d-flex flex-wrap">
								<span
									v-for="question in props.questionsInfo"
									@click="
										load_new_question(question.sequence)
									"
									:key="question.id"
									class="btn col-md-2 col-2 col-sm-1 m-1 btn-questao btn-secondary"
									:class="{
										'btn-success':
											question.selected_question_option_id !==
											null,
										'btn-current':
											question.id ===
											props.activeQuestion.testQuestion
												.id,
									}">
									{{ question.sequence }}
								</span>
							</div>
							<div class="pl-4 pb-4">
								<small>Legenda:</small>
								<br />
								<div class="row align-content-center mt-5">
									<div class="col-md-4 d-flex">
										<span class="legenda-respondida"></span>
										<small>Questão respondida</small>
									</div>

									<div class="col-md-4 d-flex">
										<span class="legenda-atual"></span>
										<small>Questão atual</small>
									</div>

									<div class="col-md-4 d-flex">
										<span
											class="legenda-nao-respondida"></span>
										<small>Questão não respondida</small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { TestQuestion } from 'resources/js/Interfaces/TestQuestion';
	import { ActiveQuestion } from 'resources/js/Interfaces/ActiveQuestion';
	import { PropType, inject } from 'vue';
	const props = defineProps({
		questionsInfo: { type: Array<TestQuestion>, required: true },
		activeQuestion: {
			type: Object as PropType<ActiveQuestion>,
			required: true,
		},
	});

	const emitter: any = inject('emitter');

	function load_new_question(question_sequence) {
		emitter.emit('reload_question', {
			action: 'specific',
			specific_sequence: question_sequence,
		});
	}
</script>

<style scoped>
	.btn-current {
		background: #fa6735 !important;
	}

	.btn-current:hover {
		color: white;
		background: #ff9d7c !important;
	}

	.btn-questao {
		border-radius: 100%;
		width: 32px;
		height: 32px;
		letter-spacing: 0px;
		font-size: 0.8em;
		color: rgb(255 255 255);
		padding: 10px 0 0 0 !important;
	}

	.legenda-respondida {
		margin-top: 2px;
		margin-right: 2px;
		height: 12px;
		width: 12px;
		background-color: #51e668;
		border-radius: 50%;
		display: inline-block;
	}

	.legenda-atual {
		margin-top: 2px;
		margin-right: 2px;
		height: 12px;
		width: 12px;
		background-color: #fa6735;
		border-radius: 50%;
		display: inline-block;
	}

	.legenda-nao-respondida {
		margin-top: 2px;
		margin-right: 2px;
		height: 12px;
		width: 12px;
		background-color: #d5d5d5;
		border-radius: 50%;
		display: inline-block;
	}
</style>
